// src/pages/IndustriesPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";



function GridRowsProStyle() {
    return (
        <style>{`
            .grid-rows-pro table tbody tr {
                transition: background 0.18s ease;
            }
            .grid-rows-pro table tbody tr:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro table tbody tr:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro table tbody tr:hover {
                background: #eff6ff !important;
            }
            .grid-rows-pro table tbody td {
                font-size: 14px;
                color: #111827;
                vertical-align: top;
            }
            .grid-rows-pro table tbody td .grid-row-main {
                font-weight: 700;
                color: #111827;
            }
            .grid-rows-pro table tbody td .grid-row-sub {
                color: #6b7280;
                font-size: 12px;
            }
            .grid-rows-pro .list-hover-item {
                transition: background 0.18s ease;
            }
            .grid-rows-pro .list-hover-item:nth-child(odd) {
                background: #ffffff;
            }
            .grid-rows-pro .list-hover-item:nth-child(even) {
                background: #f8fafc;
            }
            .grid-rows-pro .list-hover-item:hover {
                background: #eff6ff !important;
            }
        `}</style>
    );
}

const IndustriesPage = () => {
    const navigate = useNavigate();
    const [industries, setIndustries] = useState([]);
    const [oppsCountByIndustry, setOppsCountByIndustry] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError("");

                const [indRes, oppRes] = await Promise.all([
                    fetch("${API_BASE}/industries_list.php"),
                    fetch("${API_BASE}/opportunities_list.php"),
                ]);

                const indData = await indRes.json().catch(() => []);
                const oppData = await oppRes.json().catch(() => []);

                const indList = Array.isArray(indData) ? indData : [];
                const oppList = Array.isArray(oppData) ? oppData : [];

                setIndustries(indList);

                const counts = {};
                for (const o of oppList) {
                    const indId = Number(o.industry_id);
                    if (!indId) continue;
                    counts[indId] = (counts[indId] || 0) + 1;
                }
                setOppsCountByIndustry(counts);
            } catch (err) {
                console.error(err);
                setError("No se pudieron cargar los ejes / industrias.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const formatCurrency = (val) => {
        if (val == null || val === "") return "-";
        const num = Number(val);
        if (Number.isNaN(num)) return val;
        return `MXN ${num.toLocaleString()}`;
    };

    return (
        <MainLayout>
            <GridRowsProStyle />
            <div className="p-4 space-y-4 grid-rows-pro">
                {/* Header */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <div>
                        <h2 className="text-lg md:text-xl font-semibold text-cani-dark">
                            Ejes / Industrias CANIETI
                        </h2>
                        <p className="text-xs md:text-sm text-gray-500">
                            Electrónica, Telecomunicaciones y Tecnologías de la Información como
                            base de tus proyectos y oportunidades.
                        </p>
                    </div>
                    <div className="flex gap-2 text-xs">
                        {/* Si quieres que se puedan agregar más industrias a futuro */}
                        {/* <button
              type="button"
              onClick={() => navigate("/industries/new")}
              className="px-3 py-1.5 rounded-lg bg-cani-primary text-white hover:bg-cani-primaryLight"
            >
              + Nueva industria
            </button> */}
                    </div>
                </div>

                {error && (
                    <div className="mb-2 text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                        {error}
                    </div>
                )}

                {/* Tabla de industrias */}
                <div className="bg-white border border-cani-border rounded-xl shadow-sm overflow-hidden">
                    <div className="px-4 py-3 border-b border-cani-border flex items-center justify-between">
                        <h3 className="text-xs font-semibold text-cani-dark">
                            Industrias / ejes
                        </h3>
                        <span className="text-[11px] text-gray-500">
                            Total: {industries.length}
                        </span>
                    </div>

                    <div className="max-h-[70vh] overflow-y-auto">
                        <table className="min-w-full text-xs">
                            <thead className="bg-cani-bg">
                                <tr className="text-left text-[11px] font-semibold text-gray-600">
                                    <th className="px-3 py-2">Industria / Eje</th>
                                    <th className="px-3 py-2 hidden sm:table-cell">Código</th>
                                    <th className="px-3 py-2 hidden md:table-cell">Concepto</th>
                                    <th className="px-3 py-2 hidden md:table-cell">PIB (%)</th>
                                    <th className="px-3 py-2 hidden sm:table-cell">Oportunidades</th>
                                    <th className="px-3 py-2 text-right">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && (
                                    <tr>
                                        <td
                                            colSpan={6}
                                            className="px-3 py-4 text-center text-gray-500"
                                        >
                                            Cargando industrias...
                                        </td>
                                    </tr>
                                )}

                                {!loading && industries.length === 0 && (
                                    <tr>
                                        <td
                                            colSpan={6}
                                            className="px-3 py-4 text-center text-gray-400"
                                        >
                                            Aún no se han registrado industrias.
                                        </td>
                                    </tr>
                                )}

                                {!loading &&
                                    industries.map((ind) => {
                                        const indId = Number(ind.id);
                                        const oppCount = oppsCountByIndustry[indId] || 0;

                                        return (
                                            <tr
                                                key={ind.id}
                                                className="border-t border-cani-border hover:bg-cani-bg/60"
                                            >
                                                <td className="px-3 py-2 text-[11px] text-cani-dark">
                                                    <button
                                                        type="button"
                                                        onClick={() => navigate(`/industries/${ind.id}`)}
                                                        className="text-cani-primary hover:underline"
                                                    >
                                                        {ind.name}
                                                    </button>
                                                </td>
                                                <td className="px-3 py-2 hidden sm:table-cell text-[11px] text-gray-600">
                                                    {ind.code}
                                                </td>
                                                <td className="px-3 py-2 hidden md:table-cell text-[11px] text-gray-600">
                                                    {ind.concept || "-"}
                                                </td>
                                                <td className="px-3 py-2 hidden md:table-cell text-[11px] text-gray-700">
                                                    {ind.pib}
                                                </td>
                                                <td className="px-3 py-2 hidden sm:table-cell text-[11px] text-gray-700">
                                                    {oppCount}
                                                </td>
                                                <td className="px-3 py-2 text-right text-[11px] text-gray-600">
                                                    <button
                                                        type="button"
                                                        onClick={() => navigate(`/industries/${ind.id}`)}
                                                        className="px-2 py-1 rounded-lg border border-cani-border hover:bg-cani-bg"
                                                    >
                                                        Ver eje
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default IndustriesPage;
